import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Pipe, PipeTransform } from '@angular/core';
import { Subscription, timer } from 'rxjs';

import { ApiService } from '../../services/api.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-delete-modal',
    templateUrl: './delete-modal.component.html',
    styleUrls: ['./delete-modal.component.scss'],
    standalone: false
})
export class DeleteModalComponent implements OnInit {
  countDown: Subscription;
  counter = 1200; 
  tick = 1000;
  @Input() public modalData:any;
  @Output() updateData = new EventEmitter();
  note:any;
  showThiredButton:boolean = false;
  reason: string = '';
  
  constructor(
    private readonly modalService: NgbModal,
    public readonly activeModal: NgbActiveModal,
    private readonly router: Router,
    private readonly apiService: ApiService
  ) { }

  ngOnInit(): void {
    this.countDown = timer(0, this.tick).subscribe(() => --this.counter);
    if(this.modalData?.showThiredButton){
      this.showThiredButton = this.modalData?.showThiredButton;
    }

  
  }

  ngOnDestroy() {
    this.countDown.unsubscribe();
   
  }

  
  close(type:number = 0){
    if( type == 1){
      const response: any = { status: type };
      if (this.reason?.trim()) {
        response.reason = this.reason.trim();
      }
      this.activeModal.close(response);

 
      if(this.note){
        this.updateData.emit(this.note);
      }else{
      
        this.updateData.emit(response); 
      }
    }else if( type == 2){
      this.activeModal.close({status: type});
      this.updateData.emit(type);
    }
    else{
      this.activeModal.close({status: type});
    }
  }


}

@Pipe({
    name: 'formatTime',
    standalone: false
})
export class FormatTimePipe implements PipeTransform {
  transform(value: number): string {
    const minutes: number = Math.floor(value / 60);
    return (
      ('00' + minutes).slice(-2) +
      ':' +
      ('00' + Math.floor(value - minutes * 60)).slice(-2)
    );
  }
}

